import { api } from './client'

// MOCK-ONLY API — the real backend has no activity feed yet; these
// endpoints exist only in backend-mock (routes/activity.ts). Wire types
// live here (not in types.ts) until the real BE grows a counterpart.

// `new_lead` = a consumer-intake lead landed on the shop. Broadcast to the
// whole team (recipientUserId null) — there is no advisor to address it to.
export type ActivityEventKind = 'estimate_status' | 'payout' | 'customer_reply' | 'new_lead'

export interface ActivityEvent {
  id: number
  teamId: number
  kind: ActivityEventKind
  estimateId: number | null
  vehicleLabel: string | null
  fromStatus: string | null
  toStatus: string | null
  payoutAmount: number | null
  payoutPeriodLabel: string | null
  recipientUserId: number | null
  occurredAt: string
  // customer_reply only — the customer whose thread to open + the reply text.
  customerId?: number | null
  body?: string | null
  // new_lead only — the consumer's name as given at intake.
  customerName?: string | null
}

export interface ActivityFeedResponse {
  events: ActivityEvent[]
  lastReadAt: string | null
}

export const activityApi = {
  // GET /estimates/team/:teamId/activity?since=ISO — events addressed to
  // the authenticated user (+ team-wide broadcasts), newest first (BE caps
  // at 100), plus their per-team read marker.
  list: (teamId: number, since?: string) =>
    api.get<ActivityFeedResponse>(`/estimates/team/${teamId}/activity`, { since }),

  // POST /estimates/team/:teamId/activity/read — advance the caller's
  // read marker to now.
  markRead: (teamId: number) =>
    api.post<{ lastReadAt: string }>(`/estimates/team/${teamId}/activity/read`),
}
